const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

const websiteContent = {
    locations: {
        hanover: {
            address: "105 Webster St Suite 9, Hanover, MA 02339",
            hours: "Monday: 9:00 AM - 6:00 PM\nTuesday: 9:00 AM - 5:00 PM\nWednesday: 9:00 AM - 5:00 PM\nFriday: 9:00 AM - 6:00 PM",
            phone: "781-871-5030",
            fax: "781-871-5480"
        },
        // Weymouth location commented out for future use
        // weymouth: {
        //     address: "851 Main St Suite 25, Weymouth, MA 02190",
        //     hours: "Thursday: 9:00 AM - 5:00 PM",
        //     phone: "781-871-5030",
        //     fax: "781-871-5480"
        // }
    },
    insurances: [
        "Wellsense",
        "Medicare",
        "Health Plans Inc.",
        "Harvard Pilgrim",
        "Wellpoint",
        "Mass General",
        "Railroad Medicine",
        "Cigna",
        "Tufts (Public, Commercial, Medicine)",
        "Fallon Health",
        "Blue Cross Blue Shield",
        "TriCare",
        "Aetna",
        "United Healthcare"
    ],
    about: "Atlantic Primary Care has been serving our community for over 20 years. Our mission is to provide high-quality, compassionate healthcare that addresses both immediate needs and long-term wellness goals.",
    commonResponses: {
        appointment: "For lab appointments, please visit Quest Diagnostics at https://www.questdiagnostics.com/. For all other appointments, please call our office at 781-871-5030.",
        contact: "You can reach us at:\nPhone: 781-871-5030\nFax: 781-871-5480\nHanover: 105 Webster St Suite 9, Hanover, MA 02339",
        // Weymouth contact info commented out for future use
        // Weymouth: 851 Main St Suite 25, Weymouth, MA 02190
        hours: "Hanover Office:\nMonday: 9:00 AM - 6:00 PM\nTuesday: 9:00 AM - 5:00 PM\nWednesday: 9:00 AM - 5:00 PM\nFriday: 9:00 AM - 6:00 PM"
        // Weymouth hours commented out for future use
        // Weymouth Office:\nThursday: 9:00 AM - 5:00 PM
    }
};

const processResponse = (userMessage) => {
    const msg = userMessage.toLowerCase();
    
    // Direct matches for common queries
    if (msg.includes('appointment') || msg.includes('schedule')) {
        return websiteContent.commonResponses.appointment;
    }
    if (msg.includes('hour') || msg.includes('time') || msg.includes('open')) {
        return websiteContent.commonResponses.hours;
    }
    if (msg.includes('contact') || msg.includes('phone') || msg.includes('address')) {
        return websiteContent.commonResponses.contact;
    }
    
    // Location-specific queries
    if (msg.includes('hanover') || msg.includes('hanover office')) {
        return `Hanover Office:\nAddress: ${websiteContent.locations.hanover.address}\nHours: ${websiteContent.locations.hanover.hours}\nPhone: ${websiteContent.locations.hanover.phone}`;
    }
    
    // Weymouth location queries commented out for future use
    // if (msg.includes('weymouth') || msg.includes('weymouth office')) {
    //     return `Weymouth Office:\nAddress: ${websiteContent.locations.weymouth.address}\nHours: ${websiteContent.locations.weymouth.hours}\nPhone: ${websiteContent.locations.weymouth.phone}`;
    // }
    
    if (msg.includes('insurance') || msg.includes('coverage')) {
        return `We accept the following insurance plans:\n${websiteContent.insurances.join('\n')}`;
    }
    
    if (msg.includes('about') || msg.includes('who') || msg.includes('what')) {
        return websiteContent.about;
    }
    
    // Default response
    return "I'm here to help with information about Atlantic Primary Care. You can ask about appointments, office hours, locations, insurance, or general information about our practice.";
};

const generateAIResponse = async (userMessage) => {
    try {
        // First try to process with our predefined responses
        const processedResponse = processResponse(userMessage);
        if (processedResponse !== "I'm here to help with information about Atlantic Primary Care. You can ask about appointments, office hours, locations, insurance, or general information about our practice.") {
            return processedResponse;
        }
        
        // If no predefined response matches, use OpenAI API
        if (!OPENAI_API_KEY) {
            return "I'm sorry, but I'm currently unable to process your request. Please call our office at 781-871-5030 for assistance.";
        }
        
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${OPENAI_API_KEY}`
            },
            body: JSON.stringify({
                model: 'gpt-3.5-turbo',
                messages: [
                    {
                        role: 'system',
                        content: `You are a helpful assistant for Atlantic Primary Care, a medical practice in Hanover, MA. 
                        
                        Key Information:
                        - Practice: Atlantic Primary Care
                        - Location: Hanover, MA only
                        - Address: 105 Webster St Suite 9, Hanover, MA 02339
                        - Phone: 781-871-5030
                        - Fax: 781-871-5480
                        - Hours: Monday & Friday 9:00 AM - 6:00 PM, Tuesday-Thursday 9:00 AM - 5:00 PM
                        
                        Important Notes:
                        - We only have ONE location in Hanover, MA
                        - We do NOT have a Weymouth office currently
                        - For lab appointments, direct patients to Quest Diagnostics
                        - We accept most major insurance plans
                        - Dr. Nahid Kennedy is the primary physician
                        
                        Always be helpful, professional, and accurate. If you're unsure about something, direct them to call the office.`
                    },
                    {
                        role: 'user',
                        content: userMessage
                    }
                ],
                max_tokens: 500,
                temperature: 0.7
            })
        });
        
        if (!response.ok) {
            throw new Error(`OpenAI API error: ${response.status}`);
        }
        
        const data = await response.json();
        return data.choices[0].message.content;
        
    } catch (error) {
        console.error('Error generating AI response:', error);
        return "I'm sorry, I'm having trouble processing your request right now. Please call our office at 781-871-5030 for immediate assistance.";
    }
};

export { generateAIResponse, websiteContent };
